import { ReactComponent as StairsIndoor1Icon } from "../Assets/stairs_indoor_floor1.svg";
import { ReactComponent as StairsIndoor2Icon } from "../Assets/stairs_indoor_floor2 (1).svg";
import { ReactComponent as StairsOutdoor1Icon } from "../Assets/stairs_outdoor_floor1.svg";
import { ReactComponent as StairsOutdoor2Icon } from "../Assets/stairs_outdoor_floor2.svg";

export const INITIAL_PPM = 50;
export const GRID_CELL_SIZE_M = 1.22; // 2440мм / 2 клітинки = 1220мм = 1.22м
export const GRID_LINE_COLOR = "rgba(122, 118, 118, 1)";
export const GRID_BOLD_LINE_COLOR = "rgba(0, 0, 0, 1)";
export const ORIGIN_POINT_COLOR = "transparent";
// Ограничения масштабирования для всех режимов
// Минимум: 20% (0.2 * 50 = 10), Максимум: 200% (2 * 50 = 100)
export const MIN_ZOOM_SCALE = 0.5 * INITIAL_PPM; // 20% минимальный масштаб
export const MAX_ZOOM_SCALE = 4 * INITIAL_PPM; // 200% максимальный масштаб
export const MODES = {
  MODULAR: "modular",
  FRAME: "frame",
  FRAMELESS: "frameless",
};

export const PLACEMENT_RULES = {
  residential: ["residential", "stairs", "kitchen"],
  corridor: ["corridor"],
  stairs: ["residential"],
  kitchen: ["residential", "stairs"],
  laundry: ["sanitary"],
};

export const FRAMELESS_GRID_CELL_SIZE_M = 1.0;

export const MAX_FRAMELESS_WIDTH_M = 6;
export const MAX_FRAMELESS_HEIGHT_M = 4;

export const FRAME_MODE_WIDTH = 10;
export const FRAME_MODE_INITIAL_LENGTH = 16;
export const FRAME_MODE_SECTION_LENGTH = 4;

export const OBJECT_TYPES = {
  MODULE: "module",
  FRAME_STRUCTURE: "frame_structure",
  FRAMELESS_BUILDING: "frameless_building",
  WALL_SEGMENT: "wall_segment",
  JOINT_WALL_SEGMENT: "joint_wall_segment",
  FRAMELESS_WALL: "frameless_wall",
  FRAMELESS_PARTITION: "frameless_partition",
  DOCKING_JOINT: "docking_joint",
  DOOR: "door",
  GATE: "gate",
  WINDOW: "window",
  PANORAMIC_WINDOW: "panoramic_window",
  OUTLET: "outlet",
  OUTLET_DOUBLE: "outlet_double",
  LIGHT_CEILING: "light_ceiling",
  SWITCH: "switch",
  SWITCH_DOUBLE: "switch_double",
  RADIATOR: "radiator",
  KITCHEN_ELEMENT: "kitchen_element",
  BED: "bed",
  JACKS: "jacks",
  INTERNAL_WALL_TOOL: "internal_wall_tool",
  FRAMELESS_WALL_TOOL: "frameless_wall_tool",
  PLACEMENT_TYPE_WALL: "wall",
  PLACEMENT_TYPE_FLOOR: "floor",
  PLACEMENT_TYPE_CEILING: "ceiling",
  HEATER: "heater",
  TOILET: "toilet",
  WATER_HEATER: "water_heater",
  HAND_BASIN: "hand_basin",
  INTERNAL_AIR_CONDITIONER: "air_conditioner", // Внутренний блок кондиционера
  EXTERNAL_AIR_CONDITIONER: "external_air_conditioner", // Внешний блок кондиционера
  WINDOW_BLINDS: "window_blinds",
  SHOWER: "shower",
  FRAMELESS_SQUARE_METER_PRICE: "frameless_square_meter_price", // Цена за квадратный метр в безкаркасном режиме
};

export const SANITARY_ELEMENT_TYPES = [
  OBJECT_TYPES.TOILET,
  OBJECT_TYPES.HAND_BASIN,
  OBJECT_TYPES.WATER_HEATER,
  OBJECT_TYPES.SHOWER,
];

export const ELEMENT_LIMITS_PER_WALL_SEGMENT = {
  [OBJECT_TYPES.SWITCH]: 3,
  [OBJECT_TYPES.SWITCH_DOUBLE]: 3,
  [OBJECT_TYPES.OUTLET]: 3,
  [OBJECT_TYPES.OUTLET_DOUBLE]: 3,
  [OBJECT_TYPES.TOILET]: 1,
  [OBJECT_TYPES.HAND_BASIN]: 1,
  [OBJECT_TYPES.WATER_HEATER]: 1,
  [OBJECT_TYPES.HEATER]: 1,
  [OBJECT_TYPES.INTERNAL_AIR_CONDITIONER]: 1,
  [OBJECT_TYPES.EXTERNAL_AIR_CONDITIONER]: 1,
  [OBJECT_TYPES.WINDOW_BLINDS]: 1,
  [OBJECT_TYPES.SHOWER]: 1,
};

export const ELECTRICAL_ELEMENT_TYPES = [
  OBJECT_TYPES.SWITCH,
  OBJECT_TYPES.SWITCH_DOUBLE,
  OBJECT_TYPES.OUTLET,
  OBJECT_TYPES.OUTLET_DOUBLE,
];

export const CLIMATE_ELEMENT_TYPES = [
  OBJECT_TYPES.INTERNAL_AIR_CONDITIONER,
  OBJECT_TYPES.WINDOW_BLINDS,
  OBJECT_TYPES.HEATER,
];

export const SHOWER_ALLOWED_ELEMENT_TYPES = [
  OBJECT_TYPES.DOOR,
  OBJECT_TYPES.WINDOW,
  OBJECT_TYPES.PANORAMIC_WINDOW,
  ...ELECTRICAL_ELEMENT_TYPES,
];

export const TOILET_ALLOWED_ELEMENT_TYPES = [
  OBJECT_TYPES.DOOR,
  OBJECT_TYPES.WINDOW,
  OBJECT_TYPES.PANORAMIC_WINDOW,
  ...ELECTRICAL_ELEMENT_TYPES,
];

export const RESIDENTIAL_ALLOWED_ELEMENT_TYPES = [
  OBJECT_TYPES.DOOR,
  OBJECT_TYPES.WINDOW,
  OBJECT_TYPES.PANORAMIC_WINDOW,
  ...ELECTRICAL_ELEMENT_TYPES,
  ...CLIMATE_ELEMENT_TYPES,
];

export const KITCHEN_ALLOWED_ELEMENT_TYPES = [
  OBJECT_TYPES.DOOR,
  OBJECT_TYPES.WINDOW,
  OBJECT_TYPES.PANORAMIC_WINDOW,
  ...ELECTRICAL_ELEMENT_TYPES,
  ...CLIMATE_ELEMENT_TYPES,
  OBJECT_TYPES.HAND_BASIN,
  OBJECT_TYPES.KITCHEN_ELEMENT,
  OBJECT_TYPES.OUTLET_DOUBLE,
];

export const LAUNDRY_ALLOWED_ELEMENT_TYPES = [
  OBJECT_TYPES.DOOR,
  OBJECT_TYPES.WINDOW,
  OBJECT_TYPES.PANORAMIC_WINDOW,
  ...ELECTRICAL_ELEMENT_TYPES,
  ...CLIMATE_ELEMENT_TYPES,
  OBJECT_TYPES.WATER_HEATER,
  OBJECT_TYPES.KITCHEN_ELEMENT,
  OBJECT_TYPES.OUTLET_DOUBLE,
];

export const ELEMENT_GROUP_LIMITS = {
  ELECTRICAL: 3,
  SANITARY: 1,
  CLIMATE: 2,
};

export const DEFAULT_MODULE_CELLS_WIDE = 2;
export const DEFAULT_MODULE_CELLS_LONG = 5;

export const MODULE_DEFAULT_WIDTH =
  DEFAULT_MODULE_CELLS_WIDE * GRID_CELL_SIZE_M;
export const MODULE_DEFAULT_LENGTH =
  DEFAULT_MODULE_CELLS_LONG * GRID_CELL_SIZE_M;

export const defaultObjectSizes = {
  [OBJECT_TYPES.DOOR]: {
    width: 0.9,
    height: 2.1,
    depth: 0.15,
    actualDoorThickness: 0.04,
  },
  [OBJECT_TYPES.GATE]: {
    width: GRID_CELL_SIZE_M * 3,
    height: 2.1,
    depth: 1,
  },
  [OBJECT_TYPES.WINDOW]: { width: GRID_CELL_SIZE_M, height: 1.0, depth: 0.15 },
  [OBJECT_TYPES.PANORAMIC_WINDOW]: {
    width: GRID_CELL_SIZE_M * 2,
    height: 1.8,
    depth: 0.15,
  },
  [OBJECT_TYPES.OUTLET]: { width: 0.2, height: 0.2, depth: 0.025 },
  [OBJECT_TYPES.OUTLET_DOUBLE]: { width: 0.2, height: 0.2, depth: 0.025 },
  [OBJECT_TYPES.LIGHT_CEILING]: { width: 0.15, height: 1.2, depth: 0.05 },
  [OBJECT_TYPES.SWITCH]: { width: 0.18, height: 0.18, depth: 0.025 },
  [OBJECT_TYPES.SWITCH_DOUBLE]: { width: 0.25, height: 0.18, depth: 0.025 },
  [OBJECT_TYPES.RADIATOR]: { width: 0.8, height: 0.5, depth: 0.1 },
  [OBJECT_TYPES.KITCHEN_ELEMENT]: {
    width: GRID_CELL_SIZE_M,
    height: 0.8,
    depth: 0.6,
  },
  [OBJECT_TYPES.HEATER]: { width: 0.3, height: 0.4, depth: 0.6 },
  [OBJECT_TYPES.TOILET]: { width: 0.4, height: 0.8, depth: 0.7 },
  [OBJECT_TYPES.WATER_HEATER]: { width: 0.4, height: 0.6, depth: 0.4 },
  [OBJECT_TYPES.HAND_BASIN]: { width: 0.5, height: 0.85, depth: 0.4 },
  [OBJECT_TYPES.INTERNAL_AIR_CONDITIONER]: { width: 1.2, height: 0.4, depth: 0.3 },
  [OBJECT_TYPES.EXTERNAL_AIR_CONDITIONER]: { width: 1.0, height: 0.5, depth: 0.4 },
  [OBJECT_TYPES.WINDOW_BLINDS]: { width: 0.4, height: 0.075, depth: 0.15 },
  [OBJECT_TYPES.SHOWER]: { width: 0.9, height: 2.1, depth: 0.9 },
};

export const OBJECT_ELEMENT_CATEGORIES = [
  {
    titleKey: "element_categories.structures",
    items: [
      {
        type: OBJECT_TYPES.INTERNAL_WALL_TOOL,
        labelKey: "elements.internal_wall",
        placement: null,
        icon: "InternalWallSvg",
        mode: MODES.MODULAR,
      },
      {
        type: OBJECT_TYPES.FRAMELESS_WALL_TOOL,
        labelKey: "elements.internal_wall",
        placement: null,
        icon: "PencilIcon",
        mode: MODES.FRAMELESS,
      },
      {
        type: OBJECT_TYPES.FRAMELESS_SQUARE_METER_PRICE,
        labelKey: "elements.frameless_square_meter_price",
        placement: null,
        icon: "CurrencyDollarIcon",
        mode: MODES.FRAMELESS,
      },
      {
        type: OBJECT_TYPES.INTERNAL_WALL_TOOL,
        labelKey: "elements.internal_wall",
        placement: null,
        icon: "InternalWallSvg",
        mode: MODES.FRAME,
      },
    ],
  },
  {
    titleKey: "element_categories.doors_windows",
    items: [
      {
        type: OBJECT_TYPES.DOOR,
        labelKey: "elements.door",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "DoorSvg",
      },
      {
        type: OBJECT_TYPES.GATE,
        labelKey: "elements.gate",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "GateSvg",
        mode: MODES.FRAMELESS,
      },
      {
        type: OBJECT_TYPES.WINDOW,
        labelKey: "elements.window",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "WindowSvg",
      },
      {
        type: OBJECT_TYPES.PANORAMIC_WINDOW,
        labelKey: "elements.panoramic_window",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "WindowSvg",
      },
      {
        type: OBJECT_TYPES.WINDOW_BLINDS,
        labelKey: "elements.window_blinds",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "WindowBlindsSvg",
      },
    ],
  },
  {
    titleKey: "element_categories.electricity",
    items: [
      {
        type: OBJECT_TYPES.OUTLET,
        labelKey: "elements.outlet",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "SocketX1Svg",
      },
      {
        type: OBJECT_TYPES.OUTLET_DOUBLE,
        labelKey: "elements.outlet_double",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "SocketX2Svg",
      },
      {
        type: OBJECT_TYPES.SWITCH,
        labelKey: "elements.switch",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "SwitchX1Svg",
      },
      {
        type: OBJECT_TYPES.SWITCH_DOUBLE,
        labelKey: "elements.switch_double",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "SwitchX2Svg",
      },
    ],
  },
  {
    titleKey: "element_categories.sanitary",
    items: [
      {
        type: OBJECT_TYPES.TOILET,
        labelKey: "elements.toilet",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "ToiletSvg",
      },
      {
        type: OBJECT_TYPES.HAND_BASIN,
        labelKey: "elements.hand_basin",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "HandBasinSvg",
      },
      {
        type: OBJECT_TYPES.WATER_HEATER,
        labelKey: "elements.water_heater",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "WaterHeaterSvg",
      },
      {
        type: OBJECT_TYPES.SHOWER,
        labelKey: "elements.shower",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "ShowerSvg",
      },
    ],
  },
  {
    titleKey: "element_categories.climate",
    items: [
      {
        type: OBJECT_TYPES.INTERNAL_AIR_CONDITIONER,
        labelKey: "elements.air_conditioner",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "AirConditionerInternalSvg",
      },
      {
        type: OBJECT_TYPES.HEATER,
        labelKey: "elements.heater",
        placement: OBJECT_TYPES.PLACEMENT_TYPE_WALL,
        icon: "HeaterSvg",
      },
    ],
  },
];

export const WALL_THICKNESS_M_RENDER = 0.15;
export const CORRIDOR_WALL_THICKNESS_M = 0.15;
export const DOCKED_SPLIT_WALL_THICKNESS_M = 0.06;
export const DOCKED_SPLIT_WALL_OFFSET_M = 0.05;

export const STAIRS_COUNTERPART_MAP = {
  stairs_indoor_floor1: "stairs_indoor_floor2",
  stairs_indoor_floor2: "stairs_indoor_floor1",
  stairs_outdoor_floor1: "stairs_outdoor_floor2",
  stairs_outdoor_floor2: "stairs_outdoor_floor1",
};

export const STAIRS_TEXTURE_MAP = {
  stairs_indoor_floor1: StairsIndoor1Icon,
  stairs_indoor_floor2: StairsIndoor2Icon,
  stairs_outdoor_floor1: StairsOutdoor1Icon,
  stairs_outdoor_floor2: StairsOutdoor2Icon,
};

export const DRAWING_WALL_FILL_COLOR = "";
export const DRAWING_WALL_STROKE_COLOR = "";
export const DRAWING_WALL_STROKE_WIDTH = 1;
export const DRAWING_PORTAL_JAMB_FILL_COLOR = "#CBD5E1";
export const DRAWING_PORTAL_JAMB_STROKE_COLOR = "#64748B";
export const DRAWING_DOOR_FILL_COLOR = "#475569";
export const DRAWING_DOOR_STROKE_COLOR = "#1E293B";
export const DRAWING_DOOR_JAMB_FILL_COLOR = "#E2E8F0";
export const DRAWING_DOOR_SWING_COLOR = "#64748B";
export const DRAWING_DOOR_STROKE_WIDTH = 1;
export const DRAWING_WINDOW_FRAME_COLOR = "#475569";
export const DRAWING_WINDOW_GLASS_LINE_COLOR = "#94A3B8";
export const DRAWING_WINDOW_STROKE_WIDTH = 0.75;
export const DRAWING_PANORAMIC_WINDOW_FILL_COLOR = "rgba(100, 116, 139, 0.2)";
export const DRAWING_OUTLET_FILL_COLOR = "#F1F5F9";
export const DRAWING_OUTLET_STROKE_COLOR = "#64748B";
export const DRAWING_LIGHT_FILL_COLOR = "#FEF3C7";
export const DRAWING_LIGHT_STROKE_COLOR = "#F59E0B";
export const DRAWING_RADIATOR_FILL_COLOR = "#E2E8F0";
export const DRAWING_RADIATOR_STROKE_COLOR = "#64748B";
export const DRAWING_KITCHEN_ELEMENT_FILL_COLOR = "#D6D3D1";
export const DRAWING_KITCHEN_ELEMENT_STROKE_COLOR = "#78716C";
export const SELECTED_ELEMENT_COLOR = "#C71D3B";
export const PLACEMENT_HIGHLIGHT_FILL_COLOR = "rgba(74, 222, 128, 0.4)";
export const PLACEMENT_NOT_ALLOWED_FILL_COLOR = "rgba(248, 113, 113, 0.4)";
export const PLACEMENT_GENERAL_HIGHLIGHT_FILL_COLOR = "rgba(250, 204, 21, 0.3)";
export const POTENTIAL_WALL_SLOT_COLOR = "rgba(199, 29, 59, 0.4)";
export const FRAME_OFFSET_M = 0.05;
export const FRAME_LEG_LENGTH_M = 0.15;
export const FRAME_STROKE_THICKNESS_M = 0.02;
export const FRAME_STROKE_COLOR = "rgba(75, 85, 99, 0.6)";
export const FRAME_FILL_COLOR = "none";
export const EPSILON = 0.01;
export const SELECTED_WALL_SEGMENT_COLOR = "#C71D3B";
export const ELEMENT_STROKE_COLOR = "#333333";
export const SNAP_DISTANCE = 0.25;

export { GEOMETRY_TOLERANCES, UNIT_CONVERSIONS } from './config/tolerances';
